/**
 * Abstract definition for a DateProvider
 */
export type DateProvider = (...args: any[]) => Date;

